import { useState } from "react";

/**
 * Hook to copy text to clipboard with a brief flash notification.
 */
export function useClipboardFlash() {
  const [copiedRow, setCopiedRow] = useState<number | null>(null);

  const flash = (msg: string) => {
    const el = document.createElement("div");
    el.className = "copy-flash";
    el.textContent = msg;
    document.body.appendChild(el);
    setTimeout(() => el.remove(), 1200);
  };

  const copyText = (text: string, rowIdx?: number) => {
    navigator.clipboard.writeText(text);
    if (typeof rowIdx === "number") {
      setCopiedRow(rowIdx);
    }
    flash("✓ Copied");
  };

  return { copiedRow, copyText };
}
